import { adkitApi } from "../adkitApi";
import type { SluggedId } from "Models";
import type {
  CreateAdKitLocationDto,
  UpdateAdKitLocationDto,
} from "entities/requests/adkit";

type FacilityAdKitArgs = { facilityId: string; adKitId: SluggedId };
type AddLocationArgs = FacilityAdKitArgs & {
  body: CreateAdKitLocationDto[];
};
type UpdateLocationArgs = FacilityAdKitArgs & {
  locationId: SluggedId;
  body: UpdateAdKitLocationDto;
};
type DeleteLocationArgs = FacilityAdKitArgs & { locationId: SluggedId };
type DeleteLocationsArgs = FacilityAdKitArgs & { locationIds: SluggedId[] };

const locationEndpoints = adkitApi.injectEndpoints({
  endpoints: (build) => ({
    addAdKitLocation: build.mutation<unknown, AddLocationArgs>({
      query: ({ facilityId, adKitId, body }) => ({
        url: `/api/ad-kit/facility/${facilityId}/adkit/${adKitId}/locations`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_r, _e, { adKitId }) => [
        { type: "AdKit", id: adKitId },
      ],
    }),

    updateAdKitLocation: build.mutation<unknown, UpdateLocationArgs>({
      query: ({ facilityId, adKitId, locationId, body }) => ({
        url: `/api/ad-kit/facility/${facilityId}/adkit/${adKitId}/location/${locationId}`,
        method: "PATCH",
        body: { ...body, adKitMetaDataId: body.adKitMetaDataId ?? 1 },
      }),
      invalidatesTags: (_r, _e, { adKitId }) => [
        { type: "AdKit", id: adKitId },
      ],
    }),

    deleteAdKitLocation: build.mutation<unknown, DeleteLocationArgs>({
      query: ({ facilityId, adKitId, locationId }) => ({
        url: `/api/ad-kit/facility/${facilityId}/adkit/${adKitId}/location/${locationId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_r, _e, { adKitId }) => [
        { type: "AdKit", id: adKitId },
      ],
    }),

    deleteAdKitLocations: build.mutation<unknown, DeleteLocationsArgs>({
      query: ({ facilityId, adKitId, locationIds }) => ({
        url: `/api/ad-kit/facility/${facilityId}/adkit/${adKitId}/locations?[${locationIds.join(",")}]`,
        method: "DELETE",
      }),
      invalidatesTags: (_r, _e, { adKitId }) => [
        { type: "AdKit", id: adKitId },
        "AdKitList",
      ],
    }),
  }),
});

export const {
  useAddAdKitLocationMutation,
  useUpdateAdKitLocationMutation,
  useDeleteAdKitLocationMutation,
  useDeleteAdKitLocationsMutation,
} = locationEndpoints;
